/* eslint camelcase: 0 */

import { UserHistory as Data } from '@/typings/api/User'
import { Model, createMessages } from '@/helpers/Model'


export class UsersHistoryModel extends Model<Data> {
  public static readonly page_title = createMessages({
    ...Model.page_title,
    view: (data?: UsersHistoryModel) => 'История изменения пользователя «{name}»'
      .replace('{name}', data?.name || '...'),
    list: 'История изменения пользователей',
  });

  public static readonly response_error = createMessages({
    ...Model.response_error,
  });

  public static getName(data: Data) {
    return data?.user.username
  }
}
